import React, { useState, useEffect } from "react";
import axios from "axios";
import { TrendingDown, Plus, Trash2, CheckCircle2, X, Tag, Lock, Printer, Filter, Calendar } from "lucide-react";

export const KeuanganPengeluaranPage = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [notification, setNotification] = useState("");
  const [categories, setCategories] = useState([]);
  const [showKategori, setShowKategori] = useState(false);
  const [newKategori, setNewKategori] = useState("");
  const [kasAkun, setKasAkun] = useState([]);
  const [filterKategori, setFilterKategori] = useState("all");
  const [filterPeriode, setFilterPeriode] = useState("all");
  const [form, setForm] = useState({
    judul: "",
    kategori: "Bandwidth Upstream",
    nominal: 500000,
    tanggal: new Date().toISOString().split("T")[0],
    dibayarkan_kepada: "",
    metode_bayar: "Transfer Mandiri",
    keterangan: "",
    kas_akun_id: ""
  });

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${BACKEND_URL}/api/pengeluaran`, {
        withCredentials: true
      });
      setList(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${BACKEND_URL}/api/kategori-pengeluaran`, { withCredentials: true });
      setCategories(res.data || []);
    } catch (err) { console.error(err); }
  };

  const handleAddKategori = async () => {
    const nama = newKategori.trim();
    if (!nama) return;
    try {
      await axios.post(`${BACKEND_URL}/api/kategori-pengeluaran`, { nama }, { withCredentials: true });
      setNewKategori("");
      fetchCategories();
    } catch (err) { alert(err.response?.data?.detail || "Gagal menambah kategori"); }
  };

  const handleDeleteKategori = async (id) => {
    try {
      await axios.delete(`${BACKEND_URL}/api/kategori-pengeluaran/${id}`, { withCredentials: true });
      fetchCategories();
    } catch (err) { alert(err.response?.data?.detail || "Gagal menghapus kategori"); }
  };

  const fetchKasAkun = async () => {
    try {
      const res = await axios.get(`${BACKEND_URL}/api/kas/summary`, { withCredentials: true });
      setKasAkun(res.data?.akun || []);
    } catch (err) { console.error(err); }
  };

  useEffect(() => {
    fetchData();
    fetchCategories();
    fetchKasAkun();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${BACKEND_URL}/api/pengeluaran`, form, {
        withCredentials: true
      });
      setNotification("Pengeluaran operasional berhasil dicatat!");
      setShowAdd(false);
      setForm({
        judul: "",
        kategori: "Bandwidth Upstream",
        nominal: 500000,
        tanggal: new Date().toISOString().split("T")[0],
        dibayarkan_kepada: "",
        metode_bayar: "Transfer Mandiri",
        keterangan: "",
        kas_akun_id: ""
      });
      fetchData();
      setTimeout(() => setNotification(""), 4000);
    } catch (err) {
      alert("Gagal mencatat pengeluaran");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Hapus data pengeluaran ini?")) {
      try {
        await axios.delete(`${BACKEND_URL}/api/pengeluaran/${id}`, {
          withCredentials: true
        });
        fetchData();
      } catch (err) {
        alert("Gagal menghapus");
      }
    }
  };

  const esc = (v) => String(v ?? "-").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  const MONTHS = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
  const monthLabel = (ym) => {
    const [y, m] = String(ym || "").split("-");
    return `${MONTHS[parseInt(m, 10) - 1] || m} ${y}`;
  };

  const periodeOptions = Array.from(
    new Set(list.map((it) => String(it.tanggal || "").slice(0, 7)).filter((p) => p.length === 7))
  ).sort((a, b) => b.localeCompare(a));

  const filtered = list.filter((it) => {
    const okKat = filterKategori === "all" || it.kategori === filterKategori;
    const okPer = filterPeriode === "all" || String(it.tanggal || "").slice(0, 7) === filterPeriode;
    return okKat && okPer;
  });

  const totalNominal = filtered.reduce((acc, item) => acc + Number(item.nominal || 0), 0);

  const handlePrint = () => {
    const katLabel = filterKategori === "all" ? "Semua Kategori" : filterKategori;
    const perLabel = filterPeriode === "all" ? "Semua Bulan" : monthLabel(filterPeriode);
    const now = new Date().toLocaleString("id-ID");
    const rows = filtered.length
      ? filtered.map((it, i) => `<tr><td>${i + 1}</td><td>${esc(it.tanggal)}</td><td>${esc(it.judul)}</td><td>${esc(it.kategori)}</td><td>${esc(it.dibayarkan_kepada || "-")}</td><td>${esc(it.metode_bayar || "-")}</td><td class="num">Rp ${Number(it.nominal || 0).toLocaleString("id-ID")}</td></tr>`).join("")
      : `<tr><td colspan="7" style="text-align:center;color:#64748b;padding:16px">Tidak ada data untuk filter ini.</td></tr>`;
    const html = `<!DOCTYPE html><html><head><title>Laporan Pengeluaran</title><style>
      *{box-sizing:border-box} body{font-family:Arial,Helvetica,sans-serif;color:#0f172a;padding:24px}
      h1{font-size:18px;margin:0 0 2px} .sub{font-size:11px;color:#64748b;margin:0}
      .meta{margin:12px 0;font-size:11px;color:#334155}
      .meta b{color:#0f172a}
      table{width:100%;border-collapse:collapse;margin-top:10px;font-size:11px}
      th{background:#f1f5f9;text-align:left;padding:8px;border-bottom:2px solid #cbd5e1}
      td{padding:7px 8px;border-bottom:1px solid #e2e8f0}
      .num{text-align:right;font-family:monospace}
      tfoot td{font-weight:900;border-top:2px solid #0f172a;font-size:12px}
      @media print{body{padding:0}}
    </style></head><body>
      <h1>Laporan Pengeluaran Operasional</h1>
      <p class="sub">Sistem Billing Internet</p>
      <div class="meta">Kategori: <b>${esc(katLabel)}</b> &nbsp;&bull;&nbsp; Periode: <b>${esc(perLabel)}</b> &nbsp;&bull;&nbsp; Jumlah Data: <b>${filtered.length}</b><br/>Dicetak: ${esc(now)}</div>
      <table>
        <thead><tr><th>#</th><th>Tanggal</th><th>Deskripsi</th><th>Kategori</th><th>Dibayarkan Kepada</th><th>Metode</th><th class="num">Nominal (IDR)</th></tr></thead>
        <tbody>${rows}</tbody>
        <tfoot><tr><td colspan="6" style="text-align:right">TOTAL</td><td class="num">Rp ${totalNominal.toLocaleString("id-ID")}</td></tr></tfoot>
      </table>
    </body></html>`;
    const w = window.open("", "_blank", "width=900,height=1000");
    if (!w) return;
    w.document.write(html);
    w.document.close();
    w.focus();
    setTimeout(() => w.print(), 400);
  };

  return (
    <div className="space-y-6" data-testid="pengeluaran-page">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 p-5 rounded-2xl bg-[#0e1628] border border-slate-800 shadow-xl">
        <div>
          <div className="flex items-center gap-2">
            <span className="px-2 py-0.5 rounded bg-rose-500/20 text-rose-400 text-[10px] font-bold uppercase tracking-wider">
              Operational Expenses
            </span>
            <span className="text-xs text-slate-400">Total: Rp {totalNominal.toLocaleString("id-ID")}</span>
          </div>
          <h1 className="text-xl sm:text-2xl font-black text-white mt-1">
            Pengeluaran Operasional ISP
          </h1>
          <p className="text-xs text-slate-400 mt-0.5">
            Pencatatan biaya bandwidth upstream peering, sewa tiang, kabel FO, gaji teknisi & listrik.
          </p>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={() => setShowKategori(true)}
            data-testid="kelola-kategori-btn"
            className="px-4 py-2 bg-slate-800 hover:bg-slate-700 border border-slate-700 text-slate-200 text-xs font-bold rounded-xl flex items-center gap-2 transition-all"
          >
            <Tag className="w-4 h-4" />
            <span>Kelola Kategori</span>
          </button>
          <button
            onClick={() => setShowAdd(true)}
            data-testid="add-pengeluaran-btn"
            className="px-4 py-2 bg-gradient-to-r from-rose-600 to-pink-600 hover:from-rose-500 hover:to-pink-500 text-white text-xs font-bold rounded-xl shadow-lg shadow-rose-600/30 flex items-center gap-2 transition-all"
          >
            <Plus className="w-4 h-4" />
            <span>Tambah Pengeluaran</span>
          </button>
        </div>
      </div>

      {notification && (
        <div className="p-3 bg-rose-500/10 border border-rose-500/30 text-rose-300 rounded-xl text-xs flex items-center gap-2">
          <CheckCircle2 className="w-4 h-4 text-rose-400" />
          <span>{notification}</span>
        </div>
      )}

      {/* Filter & Cetak */}
      <div className="p-4 rounded-2xl bg-[#0e1628] border border-slate-800 shadow-xl flex flex-col sm:flex-row sm:items-end gap-3" data-testid="pengeluaran-filter-bar">
        <div className="flex-1">
          <label className="text-[10px] text-slate-400 mb-1 flex items-center gap-1"><Filter className="w-3 h-3" />Kategori</label>
          <select value={filterKategori} onChange={(e) => setFilterKategori(e.target.value)} data-testid="filter-kategori-select" className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100">
            <option value="all">Semua Kategori</option>
            {categories.map((c) => <option key={c.id} value={c.nama}>{c.nama}</option>)}
          </select>
        </div>
        <div className="flex-1">
          <label className="text-[10px] text-slate-400 mb-1 flex items-center gap-1"><Calendar className="w-3 h-3" />Periode Bulan</label>
          <select value={filterPeriode} onChange={(e) => setFilterPeriode(e.target.value)} data-testid="filter-periode-select" className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100">
            <option value="all">Semua Bulan</option>
            {periodeOptions.map((p) => <option key={p} value={p}>{monthLabel(p)}</option>)}
          </select>
        </div>
        <button onClick={handlePrint} data-testid="cetak-pengeluaran-btn" className="px-4 py-2 bg-gradient-to-r from-cyan-600 to-blue-600 hover:from-cyan-500 hover:to-blue-500 text-white text-xs font-bold rounded-xl shadow-lg shadow-cyan-600/30 flex items-center gap-2 justify-center">
          <Printer className="w-4 h-4" /><span>Cetak Data</span>
        </button>
      </div>

      {/* Table */}
      <div className="p-5 rounded-2xl bg-[#0e1628] border border-slate-800 shadow-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-xs">
            <thead>
              <tr className="border-b border-slate-800 text-slate-400 font-semibold">
                <th className="py-2.5 px-3">Tanggal Transaksi</th>
                <th className="py-2.5 px-3">Deskripsi</th>
                <th className="py-2.5 px-3">Kategori</th>
                <th className="py-2.5 px-3">Dibayarkan Kepada</th>
                <th className="py-2.5 px-3">Metode</th>
                <th className="py-2.5 px-3">Nominal (IDR)</th>
                <th className="py-2.5 px-3 text-right">Aksi</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800/60">
              {filtered.length === 0 && (
                <tr><td colSpan={7} className="py-8 text-center text-slate-500 text-xs" data-testid="pengeluaran-empty">Tidak ada data pengeluaran untuk filter ini.</td></tr>
              )}
              {filtered.map((item) => (
                <tr key={item.id} className="hover:bg-slate-900/40">
                  <td className="py-3 px-3 whitespace-nowrap" data-testid={`pengeluaran-tanggal-${item.id}`}>
                    <span className="text-slate-200 font-medium">
                      {item.tanggal ? new Date(`${item.tanggal}T00:00:00`).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" }) : "-"}
                    </span>
                    <p className="text-[10px] text-slate-500 font-mono">{item.tanggal}</p>
                  </td>
                  <td className="py-3 px-3">
                    <p className="font-bold text-white">{item.judul}</p>
                    {item.keterangan && <span className="text-[10px] text-slate-400">{item.keterangan}</span>}
                  </td>
                  <td className="py-3 px-3">
                    <span className="px-2 py-0.5 rounded bg-rose-500/15 text-rose-300 font-medium text-[11px]">
                      {item.kategori}
                    </span>
                  </td>
                  <td className="py-3 px-3 text-slate-200">{item.dibayarkan_kepada}</td>
                  <td className="py-3 px-3 text-slate-300">{item.metode_bayar}</td>
                  <td className="py-3 px-3 font-mono font-bold text-rose-400">
                    Rp {Number(item.nominal).toLocaleString("id-ID")}
                  </td>
                  <td className="py-3 px-3 text-right">
                    <button
                      onClick={() => handleDelete(item.id)}
                      className="p-1.5 text-rose-400 hover:bg-rose-950/60 rounded-lg"
                    >
                      <Trash2 className="w-3.5 h-3.5" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showAdd && (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-[#0f172a] border border-slate-700 rounded-2xl w-full max-w-md shadow-2xl p-5 space-y-4">
            <div className="flex justify-between items-center border-b border-slate-800 pb-3">
              <h3 className="text-sm font-bold text-white">Catat Pengeluaran Operasional</h3>
              <button onClick={() => setShowAdd(false)} className="text-slate-400">
                <X className="w-4 h-4" />
              </button>
            </div>

            <form onSubmit={handleSave} className="space-y-3">
              <div>
                <label className="block text-xs text-slate-300 mb-1">Deskripsi Pengeluaran *</label>
                <input
                  type="text"
                  required
                  value={form.judul}
                  onChange={(e) => setForm({ ...form, judul: e.target.value })}
                  placeholder="Contoh: Tagihan Bandwidth Upstream Peering 1 Gbps"
                  className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100"
                />
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs text-slate-300 mb-1">Kategori</label>
                  <select
                    value={form.kategori}
                    onChange={(e) => setForm({ ...form, kategori: e.target.value })}
                    data-testid="pengeluaran-kategori-select"
                    className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100"
                  >
                    {categories.map((c) => <option key={c.id} value={c.nama}>{c.nama}</option>)}
                  </select>
                </div>

                <div>
                  <label className="block text-xs text-slate-300 mb-1">Tanggal Transaksi *</label>
                  <input
                    type="date"
                    required
                    value={form.tanggal}
                    onChange={(e) => setForm({ ...form, tanggal: e.target.value })}
                    data-testid="pengeluaran-tanggal-input"
                    className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100"
                  />
                </div>

                <div>
                  <label className="block text-xs text-slate-300 mb-1">Nominal (Rp) *</label>
                  <input
                    type="number"
                    required
                    value={form.nominal}
                    onChange={(e) => setForm({ ...form, nominal: parseFloat(e.target.value) || 0 })}
                    className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100 font-mono"
                  />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs text-slate-300 mb-1">Dibayarkan Kepada</label>
                  <input
                    type="text"
                    value={form.dibayarkan_kepada}
                    onChange={(e) => setForm({ ...form, dibayarkan_kepada: e.target.value })}
                    placeholder="Contoh: PT Telkom / Toko FO"
                    className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100"
                  />
                </div>

                <div>
                  <label className="block text-xs text-slate-300 mb-1">Metode Bayar</label>
                  <select
                    value={form.metode_bayar}
                    onChange={(e) => setForm({ ...form, metode_bayar: e.target.value })}
                    className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100"
                  >
                    <option value="Transfer Mandiri">Transfer Mandiri</option>
                    <option value="Transfer BCA">Transfer BCA</option>
                    <option value="Cash">Cash</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-xs text-slate-300 mb-1">Sumber Dana (sinkron Kas &amp; Bank)</label>
                <select
                  value={form.kas_akun_id}
                  onChange={(e) => setForm({ ...form, kas_akun_id: e.target.value })}
                  data-testid="pengeluaran-sumber-dana-select"
                  className="w-full px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100"
                >
                  <option value="">Otomatis (sesuai metode bayar)</option>
                  {kasAkun.map((a) => <option key={a.id} value={a.id}>{a.nama}</option>)}
                </select>
                <p className="text-[10px] text-slate-500 mt-1">Saldo sumber dana ini otomatis berkurang di menu Kas &amp; Bank.</p>
              </div>

              <div className="pt-2 flex justify-end gap-2">
                <button
                  type="button"
                  onClick={() => setShowAdd(false)}
                  className="px-3 py-1.5 bg-slate-800 text-slate-300 rounded-xl text-xs"
                >
                  Batal
                </button>
                <button
                  type="submit"
                  className="px-4 py-1.5 bg-rose-600 text-white rounded-xl text-xs font-bold"
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showKategori && (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-[#0f172a] border border-slate-700 rounded-2xl w-full max-w-md shadow-2xl p-5 space-y-4" data-testid="kategori-modal">
            <div className="flex justify-between items-center border-b border-slate-800 pb-3">
              <h3 className="text-sm font-bold text-white flex items-center gap-2"><Tag className="w-4 h-4 text-rose-400" /> Kelola Kategori Pengeluaran</h3>
              <button onClick={() => setShowKategori(false)} className="text-slate-400"><X className="w-4 h-4" /></button>
            </div>
            <div className="flex gap-2">
              <input
                type="text"
                value={newKategori}
                onChange={(e) => setNewKategori(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleAddKategori(); } }}
                placeholder="Nama kategori baru, cth: Sewa Kantor"
                data-testid="new-kategori-input"
                className="flex-1 px-3 py-2 bg-slate-900 border border-slate-700 rounded-xl text-xs text-slate-100"
              />
              <button onClick={handleAddKategori} data-testid="add-kategori-btn" className="px-4 py-2 bg-rose-600 hover:bg-rose-500 text-white text-xs font-bold rounded-xl flex items-center gap-1"><Plus className="w-3.5 h-3.5" /> Tambah</button>
            </div>
            <div className="space-y-1.5 max-h-64 overflow-y-auto">
              {categories.map((c) => (
                <div key={c.id} className="flex items-center justify-between px-3 py-2 bg-slate-950/60 border border-slate-800 rounded-xl" data-testid={`kategori-item-${c.id}`}>
                  <span className="text-xs text-slate-200 flex items-center gap-2">
                    {c.nama}
                    {c.is_system && <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-cyan-500/20 text-cyan-300 border border-cyan-500/30 flex items-center gap-1"><Lock className="w-2.5 h-2.5" /> Sistem</span>}
                  </span>
                  {c.is_system ? (
                    <span className="text-[10px] text-slate-600">terkunci</span>
                  ) : (
                    <button onClick={() => handleDeleteKategori(c.id)} data-testid={`delete-kategori-${c.id}`} className="p-1.5 text-rose-400 hover:bg-rose-950/60 rounded-lg"><Trash2 className="w-3.5 h-3.5" /></button>
                  )}
                </div>
              ))}
            </div>
            <p className="text-[10px] text-slate-500">Kategori sistem dipakai untuk perhitungan laporan (Bandwidth &amp; Gaji) sehingga tidak bisa dihapus.</p>
          </div>
        </div>
      )}
    </div>
  );
};
